import PageLayout from "./components/PageLayout";

function About() {
  return (
    <PageLayout
      eyebrow="Built for enthusiasts"
      title="About MyBuildID"
      subtitle="A permanent digital home for every automotive build."
      maxWidth="680px"
    >
      <div style={cardStyle}>
        <p style={leadStyle}>
          MyBuildID helps automotive enthusiasts document their vehicles,
          organize modifications, preserve build history, and share everything
          through one clean digital profile.
        </p>

        <p style={textStyle}>
          Build details are often scattered across social media posts, old
          receipts, photo albums, notes, and conversations. MyBuildID brings
          that information together so every vehicle has a clear, organized,
          and continuously updated record.
        </p>

        <div style={dividerStyle} />

        <h2 style={sectionTitleStyle}>More than a mod list</h2>

        <p style={textStyle}>
          Each build can include photos, specifications, modifications,
          maintenance records, timeline updates, build chapters, ownership
          details, sale information, and a personalized QR show card.
        </p>

        <p style={textStyle}>
          At a car show, meet, or event, owners no longer have to repeat every
          wheel, suspension, tire, or performance detail. Visitors can simply
          scan the QR code and explore the complete build.
        </p>

        <div style={dividerStyle} />

        <h2 style={sectionTitleStyle}>Built around documentation</h2>

        <p style={textStyle}>
          MyBuildID is not designed to be a popularity contest. There are no
          rankings deciding which build matters most. Every project has a
          story, whether it is a daily driver, restoration, track car, show
          build, or long-term project.
        </p>

        <p style={textStyle}>
          The goal is simple: give every build a permanent place to be
          documented, shared, remembered, and passed on.
        </p>

        <div style={statementStyle}>
          Document your build. Share your build. Inspire the next build.
        </div>
      </div>
    </PageLayout>
  );
}

const cardStyle = {
  backgroundColor: "#181818",
  border: "1px solid #2a2a2a",
  borderRadius: "22px",
  padding: "clamp(24px, 5vw, 36px)",
  boxShadow: "0 18px 50px rgba(0, 0, 0, 0.22)",
};

const leadStyle = {
  marginTop: 0,
  marginBottom: "20px",
  fontSize: "18px",
  fontWeight: "600",
  lineHeight: "1.7",
  color: "#ffffff",
};

const textStyle = {
  margin: "0 0 18px",
  color: "#d0d0d0",
  lineHeight: "1.8",
  fontSize: "16px",
};

const sectionTitleStyle = {
  margin: "0 0 14px",
  fontSize: "20px",
  lineHeight: "1.3",
  color: "#ffffff",
};

const dividerStyle = {
  height: "1px",
  backgroundColor: "#2c2c2c",
  margin: "28px 0",
};

const statementStyle = {
  marginTop: "30px",
  padding: "18px 20px",
  borderLeft: "3px solid #e21b23",
  borderRadius: "10px",
  backgroundColor: "#111111",
  color: "#ffffff",
  fontSize: "17px",
  fontWeight: "700",
  lineHeight: "1.5",
};

export default About;